/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { type UserEntity, userSchema } from '@axiom/domain';

/** ReadUserMeResponse — dark-roast DTO: UserMeResponseDto */
export const readUserMeResponseSchema = userSchema.pick({ "candidateId": true, "contactId": true, "email": true, "firstName": true, "fullName": true, "id": true, "isActive": true, "lastName": true, "termsAndConditionsAcceptedAt": true }).extend({ "hasAcceptedTermsAndConditions": z.boolean().nullish(), "roles": z.array(z.string()) });
export type ReadUserMeResponse = Pick<UserEntity, "candidateId" | "contactId" | "email" | "firstName" | "fullName" | "id" | "isActive" | "lastName" | "termsAndConditionsAcceptedAt"> & z.infer<typeof readUserMeResponseSchema>;
